[
  "/img/agnes.jpg",
  "/img/agnus.jpg",
  "/img/ayung.jpg",
  "/img/cindy.jpg",
  "/img/fiesta.jpg",
  "/img/fireplace.jpg",
  "/img/gran-prix.jpg",
  "/img/i-drink-your-milkshake.jpg",
  "/img/navy-ball.jpg",
  "/img/pool.jpg",
  "/img/shooting.jpg",
  "/img/temple.jpg"
]
